/* eslint-disable react/prop-types */
import { HeaderGlobalBar as CarbonHeaderGlobalBar } from '@carbon/react';

export const HeaderGlobalBar = ({ children, ...props }) => (
  <CarbonHeaderGlobalBar {...props}>{children}</CarbonHeaderGlobalBar>
);
